import React, { useContext, useEffect, useState } from "react";
import Calendar from "react-calendar";
import "../../../css/Calender.css";
import { HeaderText, ServiceSettingContext } from "../ServiceSettingIndex";
import ServiceListComponent from "./ServiceListComponent";
import PrimaryButton from "../../../utils/buttons/primaryButton";
import axiosInstance, {
  notifySuccess,
} from "../../../../utility/axiosInstance";
import { toast } from "react-toastify";
import {
  setAdditionServiceInfo,
  setServiceSettingInfo,
} from "../../../../redux/serviceSlice";
import { useDispatch, useSelector } from "react-redux";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { Datepicker } from "flowbite-react";
import { InputFields } from "../../../InputField/InputFIelds";
import HolidayListComponent from "../../../Common/settingComponet/HolidayListComponent";
import WeeklyOffSetting from "../../../Common/settingComponet/WeeklyOffSetting";
import CalenderViewComponent from "../../../Common/settingComponet/CalenderViewComponent";
import { useTranslation } from "react-i18next";
import {
  compareMonthAndYear,
  compareTwoDate,
  compareTwoDateIFG,
  convertToUTCDate,
} from "../../../../utility/utils";

const CalenderComponent = () => {
  const { t } = useTranslation();
  const {
    calenderView,
    dateValue,
    onDateChange,
    weekdays,
    weeklyCheckbox,
    available,
    setAvailable,
    availableWorkingDays,
    setAvailableWorkingDays,
    handleMonthDateUpdate,
    holidays,
    currentMonth,
    applyWeeklySetting,
  } = useContext(ServiceSettingContext);
  const { serviceSettingInfo } = useSelector((state) => state?.services);

  const dispatch = useDispatch();

  const [allDate, setAllDate] = useState({
    minDate: new Date(),
    maxDate: new Date(),
  });
  // const [updateSate, setUpdate] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  // console.log(available);
  const resetMonth = () => {
    setAvailable([]);
    onDateChange(null);
    setAllDate({
      minDate: new Date(),
      maxDate: new Date(),
    });
  };
  useEffect(() => {
    try {
      let today = new Date(currentMonth);

      const currentMonthDate = new Date(currentMonth);
      let count =
        new Date(
          currentMonthDate.getFullYear(),
          currentMonthDate.getMonth() + 1,
          0
        ).getDate() ?? 30;
      let allDates = [];
      if (weeklyCheckbox && applyWeeklySetting) {
        for (let index = 0; index < count; index++) {
          let tempDate = new Date(today);
          tempDate.setDate(tempDate.getDate() + index);
          const weekday = tempDate.toLocaleDateString("en-US", {
            weekday: "long",
          });
          if (tempDate.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
            continue;
          }

          if (weeklyCheckbox[weekday]) {
            allDates.push(tempDate);
          }
        }
        let lastDay = new Date(today);
        if (serviceSettingInfo) {
          const { holidays } = serviceSettingInfo;
          if (holidays.length > 0) {
            allDates = allDates.filter((tempDate) => {
              const exist = holidays.find(({ date }) =>
                compareTwoDate(date, tempDate)
              );
              if (exist) {
                return false;
              }
              return true;
            });
          }
        }

        setAvailable(allDates);
        lastDay.setDate(lastDay.getDate() + count - 1);

        if (allDates.length > 0) {
          onDateChange(allDates[0]);
        }

        setAllDate((state) => ({ minDate: today, maxDate: lastDay }));
      } else {
        if (serviceSettingInfo) {
          if (serviceSettingInfo && currentMonth) {
            const monthYearDateData =
              serviceSettingInfo?.serviceMonthSetting.find(
                ({ monthYearDate }) =>
                  compareMonthAndYear(monthYearDate, currentMonth)
              );
 
            if (monthYearDateData) {
              monthYearDateData?.serviceDateSettings.forEach(({ date }) => {
                const tempDate = new Date(date);
                if (
                  tempDate.setHours(0, 0, 0, 0) >=
                  new Date().setHours(0, 0, 0, 0)
                ) {
                  const exist = holidays.find(({ date }) =>
                    compareTwoDate(date, tempDate)
                  );
                  if (!exist) {
                    allDates.push(tempDate);
                  }
                }
              });
            }else{
              resetMonth()
            }
          }
          if (allDates.length > 0) {
            setAvailable(allDates);
            onDateChange(allDates[0]);
            setAllDate({
              minDate: allDates[0],
              maxDate: allDates[allDates.length - 1],
            });
          }
        }else{
          resetMonth()
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, [
    weeklyCheckbox,
    calenderView,
    weekdays,
    onDateChange,
    setAvailableWorkingDays,
    serviceSettingInfo,
    currentMonth,
    applyWeeklySetting,
  ]);

  useEffect(() => {
    if (available.length > 0) {
      onDateChange(available[0]);
    }
  }, [available, onDateChange]);

  const updateHoliday = async (selectedDate, deleteDate = false) => {
    try {
      try {
        setIsLoading(true);

        const tempHoliday = holidays.filter(({ date }) =>
          compareTwoDateIFG(date, new Date())
        );
        let holidayBody = [...tempHoliday];
        if (deleteDate) {
          if (selectedDate?.length <= 0) {
            toast.error(t("usedCars.calender.selectDate"));
            return;
          }

          holidayBody = holidayBody.filter(
            ({ date: hDate }) =>
              !selectedDate.find((date) => compareTwoDate(date, hDate))
          );
        } else {
          if (!selectedDate) {
            toast.error(t("usedCars.calender.selectDate"));
            return;
          }
          const exist = tempHoliday.find(({ date }) => {
            return compareTwoDate(date, selectedDate);
          });

          if (exist) {
            toast.error(t("usedCars.calendar.dateExists"));
            return;
          }

          holidayBody = [
            ...tempHoliday,
            {
              date: convertToUTCDate(selectedDate),
            },
          ];
        }

        // return
        const response = await axiosInstance.put(
          "servicesSetting/updateServiceSettingHolidays",
          { holidays: holidayBody }
        );

        if (response?.status === 200) {
          console.log(response?.data.serviceRequestSettings);
          dispatch(
            setServiceSettingInfo(response?.data.serviceRequestSettings)
          );

          notifySuccess(t("usedCars.calendar.updateSuccess"));
        } else {
          toast.warn(t("usedCars.calendar.updateFailed"));
        }
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="flex  flex-row  md:flex-col first-line:flex-wrap gap-5 justify-center sm:justify-normal">
      <WeeklyOffSetting
        SettingContextData={useContext(ServiceSettingContext)}
      />
      <CalenderViewComponent
         DeleteMSFn={async () => {
          try {
            const response = await axiosInstance.delete(
              "/serviceRequest/deleteServiceSettingInfo",
              {
                data: {
                  monthYearDates: [currentMonth],
                },
              }
            );
            if (response.status === 200) {
              toast.success("Month Setting Deleted Successfully");
              dispatch(setServiceSettingInfo(response.data.serviceSettings));
            }
          } catch (err) {
            console.log(err);
          }
        }}
        allDate={allDate}
        handleMonthDateUpdate={async () => {
          await handleMonthDateUpdate({
            ServiceMonthSetting: {
              monthYearDate: convertToUTCDate(currentMonth),
              serviceDateSettings: availableWorkingDays,
            },
          });
        }}
        SettingContextData={useContext(ServiceSettingContext)}
        updateHoliday={updateHoliday}
      />{" "}
      {/* HolidayListComponent */}
      <HolidayListComponent
        isLoading={isLoading}
        updateHolidayFunc={updateHoliday}
        holidays={holidays}
      />
    </div>
  );
};

export default CalenderComponent;
